import "../styles/index.css"

import components from "$components/**/*.{js,jsx,js.rb,css}"

;(function () {
  const STORAGE_KEY = "theme"

  function getSystemTheme() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light"
  }

  function applyTheme(theme) {
    const effective = theme === "system" ? getSystemTheme() : theme
    document.documentElement.classList.toggle("dark", effective === "dark")
  }

  function updateToggleUI(theme) {
    document.querySelectorAll(".theme-toggle button").forEach((btn) => {
      const isActive = btn.dataset.theme === theme
      btn.classList.toggle("active", isActive)
      btn.setAttribute("aria-checked", isActive)
    })
  }

  function setTheme(theme) {
    localStorage.setItem(STORAGE_KEY, theme)
    applyTheme(theme)
    updateToggleUI(theme)
  }

  function initTheme() {
    const stored = localStorage.getItem(STORAGE_KEY) || "system"
    applyTheme(stored)
    updateToggleUI(stored)

    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", () => {
        if (localStorage.getItem(STORAGE_KEY) === "system") {
          applyTheme("system")
        }
      })
  }

  const stored = localStorage.getItem(STORAGE_KEY) || "system"
  applyTheme(stored)

  document.addEventListener("DOMContentLoaded", () => {
    initTheme()

    document.querySelectorAll(".theme-toggle button").forEach((btn) => {
      btn.addEventListener("click", () => setTheme(btn.dataset.theme))
    })

    document.querySelectorAll("[data-smooth-scroll]").forEach((el) => {
      el.addEventListener("click", (e) => {
        const href = el.getAttribute("href")
        if (href && href.startsWith("#")) {
          e.preventDefault()
          const target = document.querySelector(href)
          if (target) target.scrollIntoView({ behavior: "smooth" })
        }
      })
    })
  })
})()
